import React from 'react';
import About from '../components/About/About';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Contact from '../components/Contact/Contact';
import Projects from '../components/Projects/Projects';
// import Services from '../components/Services/Services';
import Skills from '../components/Skills/Skills';

const Home = ({toggleDarkMode, isMoon}) => {
    return (
        <>
            <Header toggleDarkMode={toggleDarkMode} isMoon={isMoon}/>
            <Hero isMoon={isMoon}/>
            <About/>
            <Skills/>
            <Projects/>
            {/* <Services/> */}
            <Contact/>
        </>
    );
};

export default Home;